import React from "react";
import { Button, Card, Col, Container, Dropdown, Form, InputGroup, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatMoney } from "../../../shared/utils/formatting";
import PageTitle from "../../../shared/components/PageTitle";
import { useBillList } from "../hooks/useBillList";

function BillList() {
    const { listGrouped, merge, handleCheckMerge, handleMerge } = useBillList();

    return (
        <>
            <PageTitle>Bills list</PageTitle>
            <Card className="my-3">
                <Card.Body className="py-2">
                    <InputGroup>
                        <InputGroup.Text className="border-0 bg-transparent">
                            <i className="bi bi-search"></i>
                        </InputGroup.Text>
                        <Form.Control className="border-0" placeholder="Market, Apple" />
                        <Button className="text-secondary" variant="link">
                            <i className="bi bi-sort-down"></i>
                        </Button>
                        <Dropdown>
                            <Dropdown.Toggle bsPrefix="text-secondary" variant="link">
                                <i className="bi bi-collection"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item eventKey="1">By date</Dropdown.Item>
                                <Dropdown.Item eventKey="2">By purchase location</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </InputGroup>
                </Card.Body>
            </Card>
            {merge.length > 0 ? (
                <Container
                    fluid
                    className="fixed-top p-3 pb-4 bg-white d-flex justify-content-between z-2"
                >
                    <Col className="d-flex flex-row align-items-center justify-content-between">
                        <Link className="p-2" to={"create"}>
                            Create
                        </Link>
                        <Button variant="outline-primary" onClick={handleMerge}>
                            Merge bills
                        </Button>
                    </Col>
                </Container>
            ) : (
                <></>
            )}
            {Object.keys(listGrouped).map((date, index) => (
                <Row key={index} className="px-2">
                    <h2>{date}</h2>
                    {listGrouped[date].map((item, index) => (
                        <Col key={index} xs={6} sm={4} md={3}>
                            <Card
                                className={
                                    "shadow-sm mb-3" +
                                    (item.checked ? " bg-accent-15 border-1 border-primary" : "")
                                }
                            >
                                <Card.Body>
                                    <input
                                        className="form-check-input fs-4 position-absolute top-0 start-100 translate-middle"
                                        type="checkbox"
                                        checked={item.checked || false}
                                        onChange={(event) => handleCheckMerge(event, date, index)}
                                    />
                                    <h3 className="fs-5 mb-2">
                                        <i className="bi bi-shop-window text-primary"></i> {item.where}
                                    </h3>
                                    <strong className="text-primary text-nowrap d-block">
                                        {formatMoney(item.total)}
                                    </strong>
                                    <span className="text-muted text-wrap d-block">
                                        {item.items[0] && item.items[0].description}
                                        {item.items.length > 1 &&
                                            " and " + (item.items.length - 1) + " more"}{" "}
                                    </span>
                                    <Link to={`edit/${item.id}`}>
                                        <h6 className="btn btn-primary text-white mt-3"> Modify</h6>
                                    </Link>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            ))}
        </>
    );
}

export { BillList };
